import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import FSFlatButton from '../../../src/components/lib/FSFlatButton';
import FSLogo from '../../../static/images/homepage-icons/fs-tailfin.svg';

const leftButtons = [
  { label: 'flight tracker', link: '/flight-tracker', gaLabel: 'flightTracker' },
  { label: 'current conditons', link: '/airport-conditions', gaLabel: 'currentConditons' },
  { label: 'airport delays', link: '/airport-delays', gaLabel: 'airportDelays' },
  { label: 'data exports', link: '/data-exports', gaLabel: 'dataExports' },
  { label: 'global cancellation and delays', link: '/global-cancellations-and-delays', gaLabel: 'globalCancellationDelays' },
  { label: 'airline performance reports', link: '/monthly-performance-reports/airlines', gaLabel: 'airlinePerformanceReports' },
  { label: 'airport performance reports', link: '/monthly-performance-reports/airports', gaLabel: 'airportPerformanceReports' },
];
const rightButtons = [
  { label: 'flight alerts', link: '/flight-alerts', gaLabel: 'flightAlerts' },
  { label: 'historical flight status', link: '/historical-flight', gaLabel: 'historicalFlightStatus' },
  { label: 'departures and arrivals', link: '/airports/departing-arriving', gaLabel: 'departuresArrivals' },
];

const handleClick = (link, dispatch) => dispatch(push(link));

const FeaturesSection = props => (
  <div className='homepage-features-section'>
    <div className='homepage-features-title-content'>
      <h3 className='homepage-features-center-heading'>Welcome to FlightStats</h3>
      <h3 className='homepage-features-center-heading-lower'>
        Explore the many sections of our website and learn why FlightStats is the trusted source for
        your day of travel needs.
      </h3>
    </div>
    <div className='homepage-features-main-content'>
      <div className='homepage-features-col'>
        <h4 className='homepage-features-col-heading homepage-features-col-heading-left'>Free Services That Ease the Day of Travel</h4>
        <div className='homepage-features-button-group'>
          {leftButtons.map(o => (
            <div
              className='homepage-features-button-container'
              key={`${o.label}`}
            >
              <FSFlatButton
                label={o.label}
                onClick={() => {
                  props.reportButtonPress(o.gaLabel);
                  handleClick(o.link, props.dispatch);
                }}
              />
            </div>
          ))}
        </div>
      </div>
      <div className='homepage-features-col homepage-features-dynamic-content'>
        <h3 className='homepage-features-center-heading'>Welcome to FlightStats</h3>
        <img src={FSLogo} style={{ width: '100%' }} />
        <h3 className='homepage-features-center-heading-lower'>
          Explore the many sections of our website and learn why FlightStats is the trusted source
          for your day of travel needs.
        </h3>
      </div>
      <div className='homepage-features-col'>
        <h4 className='homepage-features-col-heading'>Premium Tools for the Advanced Travelers</h4>
        <p className='homepage-features-col-subheading'>{props.user && props.user.subscriptionActive ? '' : 'Subscription Required'}</p>
        <div className='homepage-features-button-group'>
          {rightButtons.map(o => (
            <div
              className='homepage-features-button-container'
              key={`${o.label}`}
            >
              <FSFlatButton
                label={o.label}
                onClick={() => {
                  props.reportButtonPress(o.gaLabel);
                  handleClick(o.link, props.dispatch);
                }}
              />
            </div>
          ))}
        </div>
        <div className={`homepage-features-subscription-box ${props.user && props.user.subscriptionActive && 'homepage-features-user-subscribed'}`}>
          <div className='homepage-features-subscription-lockup'>
            <h3 className='homepage-features-subscription-heading'>subscriptions start at</h3>
            <h2 className='homepage-features-subscription-amount'>$2.99</h2>
          </div>
          <FSFlatButton
            onClick={() => {
              props.reportButtonPress('getSubscription');
              handleClick('/register/plan', props.dispatch);
            }}
            label='get a subscription'
          />
        </div>
      </div>
    </div>
  </div>
);

FeaturesSection.propTypes = {
  dispatch: PropTypes.func,
  reportButtonPress: PropTypes.func,
  user: PropTypes.object,
};

export default FeaturesSection;



// WEBPACK FOOTER //
// ./modules/Homepage/components/FeaturesSection.js